import { object, string, number, date } from 'yup'

export const contactFormValidation = object({
  message: string().optional(),
})

export const prescreenFormValidation = object({
  moveInDate: date(),
  preferredLeaseTerm: string(),
  householdMonthlyIncome: number(),
  occupy: number(),
})
